"use strict";

import { addEvent } from "../addEvent/addEvent";

export function goToFirstSection() {
  const toNextBtn = document.getElementsByClassName("scroll-to-first-section");
  if (toNextBtn.length == 0) return;

  let target = document.body.getElementsByClassName("main-page-section");
  
  if (target.length == 0) return;
  target = target[0];

  toNextBtn[0].addEventListener("click", (event) => {
    event.stopPropagation();
    event.preventDefault();

    if (window.smoothScroll) {
      console.log('window.smoothScroll');
      window.smoothScroll.scrollIntoView(target, {
        offsetTop: 0,
        alignToTop: true,
        onlyScrollIfNeeded: false,
      });
    } else {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  });
}